import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    "& .MuiInputBase-root": {
      paddingTop: 16,
      paddingRight: 0,
      paddingBottom: 16,
      paddingLeft: 0
    },
    "& .MuiInputBase-input": {
      paddingRight: 16,
      paddingLeft: 16,
      lineHeight: "22px",
      [theme.breakpoints.down("xs")]: {
        lineHeight: "18px"
      }
    }
  },
  formBox: {
    padding: 20,
    paddingBottom: 10,
    marginBottom: 0
  },
  actions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: 10,
    paddingTop: 4,
    paddingRight: 0
  },
  button: {
    fontSize: 16,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: theme.palette.primary.dark
  },
  save: {
    color: theme.palette.secondary.dark
  }
}));
